module.exports = __webpack_public_path__ + "static/media/no-image.21bff30d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/no-image.png
// module id = 28
// module chunks = 1